import { Helmet } from 'react-helmet-async';

type JsonLd = Record<string, unknown>;

type Props = {
  title: string;
  description: string;
  path?: string;
  image?: string;
  type?: 'website' | 'article';
  keywords?: string;
  jsonLd?: JsonLd | JsonLd[];
};

const SITE_URL = 'https://nexsollabs.com';
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;
const DEFAULT_KEYWORDS =
  'custom software development Skopje, software development North Macedonia, развој на софтвер, custom софтвер Македонија, SaaS development, web development Skopje, Laravel React agency, AI integration, ERP system, Nexsol Labs';

export default function SEO({
  title,
  description,
  path = '/',
  image = DEFAULT_IMAGE,
  type = 'website',
  keywords,
  jsonLd,
}: Props) {
  const url = `${SITE_URL}${path}`;
  const fullTitle = title.includes('Nexsol Labs') ? title : `${title} | Nexsol Labs`;
  const finalKeywords = keywords || DEFAULT_KEYWORDS;

  const jsonLdArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={finalKeywords} />
      <link rel="canonical" href={url} />

      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="Nexsol Labs" />
      <meta property="og:locale" content="en_US" />
      <meta property="og:locale:alternate" content="mk_MK" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />

      {jsonLdArray.map((data, i) => (
        <script key={i} type="application/ld+json">
          {JSON.stringify(data)}
        </script>
      ))}
    </Helmet>
  );
}
